import React, { useEffect, useState } from "react";
import { prospectStatusOptions } from "../../ProspectFilters";
import { useTranslation } from "react-i18next";
import Select from "../../../Common/FormElements/Select/Select";
import Separator from "../../../Common/Separator/Separator";
import Button from "../../../Common/FormElements/Button/Button";
import Action from "./Action";
import { useDispatch, useSelector } from "react-redux";
import { getInterlocutors } from "../../../../REDUX/actions/interlocutor";
import ActionForm from "./ActionForm";
import LoadingView from "../../../../Utils/ViewWrapper/LoadingView/LoadingView";

const Actions = ({ handleStatusChange, currentStatus, initialValues = [] }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [status, setStatus] = useState(
    currentStatus
      ? { name: t(`${currentStatus}`), code: currentStatus }
      : prospectStatusOptions(t)[0],
  );
  const { currentProspect } = useSelector((state) => state?.prospectsReducer);
  const { loading } = useSelector((state) => state?.interlocutorReducer);
  const [newAction, setNewAction] = useState();
  const [isOpen, setIsOpen] = useState();

  useEffect(() => {
    handleStatusChange(status);
  }, [status, handleStatusChange]);

  useEffect(() => {
    const controller = new AbortController();
    dispatch(getInterlocutors(currentProspect?.id, controller.signal));
    return () => controller.abort();
  }, [currentProspect?.id, dispatch]);

  if (loading) {
    return <LoadingView />;
  }

  return (
    <div className="flex-1 d-flex flex-column">
      <div className="modalContent pt-4 pb-5">
        <div className="mb-4 max-w-300px px-5">
          <p className="f16 text-ultraBlack mb-2">{t("Status")}</p>
          <Select
            name="status"
            value={status}
            label={t("Status")}
            placeholder={t("Status")}
            options={prospectStatusOptions(t)}
            appendToSelf
            callback={(e) => setStatus(e.target.value)}
          />
        </div>
        {initialValues?.length > 0 && (
          <div className="d-flex flex-column mt-5 position-relative pt-4 px-4">
            <span className="position-absolute top-0 ms-5 start-22 br5 h-100-25px border border-gray-100 w-6px" />
            {initialValues?.map((action) => (
              <Action
                key={action?.id}
                data={action}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
              />
            ))}
          </div>
        )}
        <Separator className="my-4 mx-5" />
        <div className="px-5">
          {newAction ? (
            <ActionForm
              status={status?.code}
              action={newAction}
              handleClose={() => setNewAction()}
            />
          ) : (
            <div className="d-flex gap-4">
              <Button onClick={() => setNewAction("ACTION")}>
                {t("Add an action")}
              </Button>
              <Button onClick={() => setNewAction("REMINDER")}>
                {t("Add a reminder")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Actions;
